
const uploadAttemptStatuses = {
    STARTED: "STARTED"
}

export default uploadAttemptStatuses